var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 75,
    viewBox: "0 0 65 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9286 34.8215L48.2143 45.5357H37.5L28.125 54.9107V45.5357H16.0714V5.35718H58.9286V34.8215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3929 0L0 13.3929V61.6071H16.0714V75L29.4643 61.6071H40.1786L64.2857 37.5V0H13.3929ZM58.9286 34.8214L48.2143 45.5357H37.5L28.125 54.9107V45.5357H16.0714V5.35714H58.9286V34.8214Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8929 14.7322H45.5358V30.8036H50.8929V14.7322Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1607 14.7322H30.8036V30.8036H36.1607V14.7322Z",
    fill: "#9146FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.2857,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider2);
export default __webpack_public_path__ + "static/media/slider-2.6c369eb030450767f5ec182f8bf30e0c.svg";
export { ForwardRef as ReactComponent };